import React from 'react'
import cx from 'classnames'
import { Field } from 'redux-form'
import { Input, Popup } from 'semantic-ui-react'

import { ComponentContainer } from 'shared/StyledComponents'

import translate from './translate'
import { getValidationClasses } from 'loankeeper-common/helpers'

class FloatField extends React.PureComponent {
  state = {
    errorOpen: false,
    error: '',
  }

  handleKeyPress = (event) => {
    const { currentTarget, key } = event

    if ((currentTarget.value && isNaN(currentTarget.value)) || (isNaN(key) && ![',', '.'].includes(key))) {
      this.setState({
        errorOpen: true,
        error: translate('HINT_ERR_NUMBER_ONLY'),
      })
    } else if (this.state.error) {
      this.setState({
        errorOpen: false,
        error: '',
      })
    }
  }

  isValueValid = (value) => !value || (!isNaN(value) && value.replace(/(\.|\,|\-)/gm, '').length < 37)

  handleInputChange = (_, { value }) => {
    const changedValue = value.includes(',') ? value.replace(/\,/gi, '.') : value
    if (this.isValueValid(changedValue)) {
      if (this.props.customOnChange) {
        this.props.customOnChange(changedValue)
      }
      this.props.input.onChange(changedValue)
    }
  }

  handleInputBlur = (event) => {
    this.setState({ errorOpen: false, error: '' })

    this.props.input.onBlur(event)
  }

  render() {
    const { meta, input, className, required, GetError, customOnChange, autoComplete, ...rest } = this.props

    const open = (meta.active && meta.error && meta.touched) || this.state.errorOpen
    const error = this.state.error || meta.error

    const popupClasses = cx(className, 'LKError', {
      'LKError--hidden': !open || error === 'invalid',
    })

    const inputClasses = getValidationClasses(meta.error, required, meta.touched)

    return (
      <Popup
        className={popupClasses}
        style={{ minWidth: 100 }}
        on="focus"
        popperDependencies={[error, open]}
        popperModifiers={{ preventOverflow: { enabled: false } }}
        trigger={
          <ComponentContainer input>
            <Input
              {...rest}
              {...input}
              type="text"
              fieldtype="float"
              fluid
              onKeyPress={this.handleKeyPress}
              onBlur={this.handleInputBlur}
              className={inputClasses}
              onChange={this.handleInputChange}
              autoComplete={autoComplete}
            />
          </ComponentContainer>
        }
      >
        {GetError && <GetError error={error} />}
      </Popup>
    )
  }
}

class DecoratedField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      focused: false,
      scale: this.props.scale || 2,
    }
  }

  handleFocus = () => {
    this.setState({ focused: true })
    if (this.props.onFocus) this.props.onFocus()
  }

  handleBlur = () => {
    this.setState({ focused: false })
    if (this.props.onBlur) this.props.onBlur()
  }

  currencyFormater = (value) => {
    let formatedCurrency
    if (value !== 0 && value !== undefined && this.state.focused) {
      if (
        value.toString().charAt(0) === '0' &&
        value.toString().length > 1 &&
        !(value.toString() === '0.' || value.toString() === '0.0')
      ) {
        formatedCurrency = parseFloat(value)
      } else {
        formatedCurrency = value
      }
    } else if (!value || value === '' || value === 0) {
      formatedCurrency = ''
    } else {
      formatedCurrency = parseFloat(value)
        .toFixed(this.state.scale)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }

    return formatedCurrency
  }

  render() {
    return (
      <Field
        {...this.props}
        component={FloatField}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        format={this.props.format ? this.currencyFormater : (value) => value}
        scale={this.state.scale}
      />
    )
  }
}

export default DecoratedField
